import { useState } from "react";
import { IMAGES } from "@/lib/product";

const GALLERY = [
  [IMAGES.packSide, "Unités intérieure et extérieure", true],
  [IMAGES.packStacked, "Unités empilées", true],
  [IMAGES.hoseWindow, "Liaison par la fenêtre", false],
  [IMAGES.office, "En situation : bureau", false],
  [IMAGES.attic, "En situation : sous les toits", false],
  [IMAGES.outdoorWindow, "Unité extérieure sur fenêtre", false],
];

export const ProductGallery = () => {
  const [i, setI] = useState(0);
  const [src, alt, contain] = GALLERY[i];
  return (
    <div data-testid="product-gallery" className="flex flex-col gap-3">
      <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-white border border-slate-200">
        <img data-testid="gallery-main-image" src={src} alt={alt} className={`w-full h-full ${contain ? "object-contain p-4" : "object-cover"}`} />
      </div>
      <div className="grid grid-cols-6 gap-2">
        {GALLERY.map(([s, a, c], k) => (
          <button key={s} type="button" onClick={() => setI(k)} data-testid={`gallery-thumb-${k}`} aria-label={a}
            className={`aspect-square rounded-lg overflow-hidden bg-white border-2 transition-colors ${k === i ? "border-sky-600" : "border-slate-200 hover:border-sky-300"}`}>
            <img src={s} alt="" className={`w-full h-full ${c ? "object-contain p-1" : "object-cover"}`} loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
};
